import React from "react";
import ReactDOM from "react-dom/client";
import { UnoStoreHooks, unoStore } from "@simulanisindia/ui";
import App from "./App";
import "./assets/css/main.scss";
import "./assets/css/dashboard.scss";
import "./assets/css/responsive.scss";
import "./assets/css/mobileOnly.scss";
import { Provider } from "react-redux"; 
import { BrowserRouter } from "react-router-dom";
import { store } from "./store/store";
const root = ReactDOM.createRoot(document.getElementById("root"));

const { UnoProvider } = UnoStoreHooks;

root.render(
  <UnoProvider store={unoStore}>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </UnoProvider>
);
